import { ReactNode } from 'react'

import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Product } from '@/interfaces/catalog/Product'
import { ProductSummary } from '@/lib/catalog/catalogTypes'

import { ProductItem } from './ProductItem'

interface ProductsProps {
  products: Product[] | undefined
  summaries?: Map<string, ProductSummary>
  categoryById?: Map<string, { name: string; path: string }>
  isLoading?: boolean
  showStock?: boolean
  refresh?: () => void
  empty?: ReactNode
  footer?: ReactNode
}

/** Tabulka produktů: náhled a název, kategorie, varianty, cena, sklad, stav. */
export const Products = ({
  products,
  summaries,
  categoryById,
  isLoading,
  showStock,
  refresh,
  empty,
  footer,
}: ProductsProps) => (
  <div className="overflow-hidden rounded-lg border">
    <Table>
      <TableHeader>
        <TableRow className="hover:bg-transparent">
          <TableHead>Produkt</TableHead>
          <TableHead className="hidden w-48 md:table-cell">Kategorie</TableHead>
          <TableHead className="hidden w-24 text-right md:table-cell">Varianty</TableHead>
          <TableHead className="text-right md:w-52">Cena</TableHead>
          {showStock && <TableHead className="hidden w-32 text-right md:table-cell">Skladem</TableHead>}
          <TableHead className="hidden w-28 md:table-cell">Stav</TableHead>
          <TableHead className="w-px" />
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading && Array.from({ length: 8 }).map((_, index) => <ProductItem key={index} showStock={showStock} />)}
        {!isLoading &&
          products?.map((product) => {
            const category = product.mainCategoryId ? categoryById?.get(product.mainCategoryId) : undefined
            return (
              <ProductItem
                key={product.id}
                product={product}
                summary={summaries?.get(product.id)}
                categoryName={category?.name}
                categoryPath={category?.path}
                showStock={showStock}
                onDelete={refresh}
              />
            )
          })}
      </TableBody>
    </Table>
    {!isLoading && products?.length === 0 && empty}
    {footer}
  </div>
)
